import React, { Component } from 'react';
import { Request } from 'components/Request';
import { CharacterComponent } from 'react/CharacterComponent';
import { Character } from 'models/Character';
import { CircleLoaderComponent } from 'react/CircleLoaderComponent';
import LoaderFullPage from "../elements/LoaderFullPage";

const CHARACTER_MAX_WIDTH = 64;
const CHARACTER_MAX_HEIGHT = 64;

export default class EditMains extends Component {
	constructor(props) {
		super(props);

		this.state = {
			characters: null,
			search: '',
		};
		this.loadLadderCharacters();
		this.updateMain = this.updateMain.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.clearSearch = this.clearSearch.bind(this);
	}

	updateMain(character) {
		const { ladder, player } = this.props;
		const mains = player.ladder_information.getMainsForLadderAsMap(ladder.id);
		const data = {};
		data.character_id = character.id;
		data.add_main = !mains.has(character.id);
		data.ladder_id = ladder.id;
		if(data.add_main) {
			player.ladder_information.addMainForLadder(ladder.id, Character.retrieve(character));
		}
		else {
			player.ladder_information.removeMainForLadder(ladder.id, Character.retrieve(character));
		}
		this.forceUpdate();
		Request.apiv1('player/edit_mains', data)
			.then((response) => {
				this.forceUpdate();
			})
			.catch(Request.generalJsonError);
	}

	onSearchChange(event) {
		this.setState({ search: event.target.value });
	}

	clearSearch() {
		this.setState({ search: '' });
	}

	loadLadderCharacters() {
		const { ladder } = this.props;
		ladder.getCharacters().then((characters) => {
			this.setState({ characters: characters });
		}).catch((error) => {
			Request.generalJsonError(error);
			console.error(error);
		});
	}

	render() {
		const { ladder, player } = this.props;
		const { characters, search } = this.state;

		if(!characters) {
			return (
				<div className='character_order'>
					<LoaderFullPage
						text={`Finding ${ladder.name} Characters`}
					/>
				</div>
			);
		}

		const mains = player.ladder_information.getMainsForLadderAsMap(ladder.id);
		const mainsArray = Array.from(mains.values());

		const normalizedSearch = search.trim().toLowerCase();
		const sizeProps = (character) => {
			const tooWide = character.width > CHARACTER_MAX_WIDTH;
			const tooTall = character.height > CHARACTER_MAX_HEIGHT;
			if(!tooWide && !tooTall) {
				return {};
			}
			return { maxWidth: CHARACTER_MAX_WIDTH, maxHeight: CHARACTER_MAX_HEIGHT };
		};

		const characterComponents = [];
		_.each(characters, (character) => {
			if(normalizedSearch && !(character.name || '').toLowerCase().includes(normalizedSearch)) {
				return;
			}
			characterComponents.push(
				<label
					className={`character_selection_holder ${mains.has(character.id) ? 'selected' : ''}`}
					key={character.id}
				>
					<CharacterComponent
						onClick={this.updateMain}
						character={character}
						{...sizeProps(character)}
					/>
				</label>
			);
		});

		return (
			<div className='mains_edit'>
				<div className='panel-body'>
					<div className='mains_edit__search'>
						<input
							type='text'
							className='form-control mains_edit__search-input'
							placeholder={`Search ${ladder.name} characters...`}
							value={search}
							onChange={this.onSearchChange}
							autoFocus
						/>
						{search &&
						<button
							type='button'
							className='mains_edit__search-clear'
							onClick={this.clearSearch}
							title='Clear search'
						>
							×
						</button>
						}
					</div>

					<div className='mains_edit__characters-scroll'>
						<div className='characters'>
							{characterComponents}
							{characterComponents.length === 0 &&
							<div className='mains_edit__no-results'>
								No characters match "{search}"
							</div>
							}
						</div>
					</div>

					{mainsArray.length > 0 &&
					<div className='mains_edit__selections'>
						<h5>Selections</h5>
						<div className='character_order'>
							{mainsArray.map((character) => (
								<CharacterComponent
									key={character.id}
									onClick={this.updateMain}
									character={character}
									{...sizeProps(character)}
								/>
							))}
						</div>
					</div>
					}
				</div>
			</div>
		);
	}
}
